export { default } from "./properties";
